<template>
  <v-app>
    <!--編輯-->
    <v-dialog v-model="isVisible"
              no-click-animation
              max-width="80%">
      <v-card>
        <v-card-title>嘉好案件類別編輯</v-card-title>
        <v-card-text>
          <v-layout>
            <vue-tags-input
              placeholder="表單類別"
              v-model="tag"
              :tags="tags"
              @tags-changed="newTags => tags = newTags"
            />
          </v-layout>
          <v-layout>
            <v-flex>
              <span style="color: red;">{{message}}</span>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" dark text @click="closeEvent">取消</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark text  :loading="saveLoading" @click="saveSetting()">儲存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import { mapActions } from 'vuex';
export default {
  name: 'CCHCategoryDialog',
  components:{
    VueTagsInput
  },
  props: {
    visible: Boolean,
  },
  data(){
    return {
      tag:'',
      tags: [],
      saveLoading: false,
      isVisible: false,
      message: '',
    }
  },
  watch: {
    visible(value) {
      this.message = '';
      this.isVisible = value;
    },
    isVisible(value) {
      if (!value) {
        this.closeEvent()
      }else {
       this.loadData();
      }
    },
  },
  methods: {
    ...mapActions(['saveCCHCategorySetting', 'loadCCHCategorySetting']),
    async loadData(){
      const res = await this.loadCCHCategorySetting();
      const result = res.data;
      this.tags = result.data;
      console.log(`tags = ${JSON.stringify(result)}`);
    },
    async saveSetting(){
      this.saveLoading = true;
      const res = await this.saveCCHCategorySetting({
        tags: this.tags,
      });
      this.saveLoading = false;
      const result = res.data;
      console.log(`result ${JSON.stringify(result)}`);

      this.message = result.message;
      setTimeout(()=>{
        this.message = '';
      }, 3000);
    },
    closeEvent() {
      this.isVisible = false;
      this.$emit('closeEvent');
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CCHCategoryDialog.vue